module.exports = __webpack_public_path__ + "img/home.png.665c17bc.webp";